import { TooltipButton } from "@simplicity/ui";
import { ChevronDown, ChevronUp, Pencil, Trash2 } from "lucide-react";

export function GroupRow({
  group,
  isDefault,
  isExpanded,
  onToggle,
  onRename,
  onDelete,
  children,
}: {
  group: { id: string; name: string };
  isDefault: boolean;
  isExpanded: boolean;
  onToggle: () => void;
  onRename: () => void;
  onDelete: () => void;
  children?: React.ReactNode;
}) {
  return (
    <div>
      {/* eslint-disable-next-line jsx-a11y/prefer-tag-over-role -- row click surface with nested action buttons (rename, delete) and child interactive content; semantic <button> would nest interactives. */}
      <div
        role="button"
        tabIndex={0}
        className="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-muted/50 transition-colors"
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <div className="flex items-center gap-3">
          {isExpanded ? (
            <ChevronUp className="h-4 w-4 text-muted-foreground" />
          ) : (
            <ChevronDown className="h-4 w-4 text-muted-foreground" />
          )}
          {/* Rename sits directly against the name so the pencil reads as
              "edit this text" rather than as a generic row action. */}
          <div className="flex items-center gap-1">
            <span className="text-sm font-medium">{group.name}</span>
            <TooltipButton
              label={`Rename group ${group.name}`}
              side="top"
              variant="ghost"
              size="sm"
              className="h-auto w-auto p-1 text-muted-foreground hover:text-foreground"
              onClick={(e) => {
                e.stopPropagation();
                onRename();
              }}
            >
              <Pencil className="h-4 w-4" aria-hidden="true" />
            </TooltipButton>
          </div>
          {isDefault && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary font-medium">
              Default
            </span>
          )}
        </div>
        <TooltipButton
          label={`Delete group ${group.name}`}
          side="top"
          variant="ghost"
          size="sm"
          className="h-auto w-auto p-1 text-muted-foreground hover:text-destructive"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <Trash2 className="h-4 w-4" aria-hidden="true" />
        </TooltipButton>
      </div>
      {isExpanded && children}
    </div>
  );
}
